<template lang="pug">
  .wrapper
    label.fs-19(style="grid-row: 1; grid-column: 1 / 2; font-style: italic;") acúmulo
    label.fs-19(style="grid-row: 1; grid-column: 2 / 3; font-style: italic;") compensação

    .positive(v-for="(value,lineIndex) in positiveNames" :style="`grid-row: ${2 + lineIndex}`")
      label {{value.name}}
      PTextField.input(
        :disabled="dailyCheck[value.index]"
        label=""
        type="number",
        parser="float"
        v-model="dailyLimitPerHourKind[value.index]"
      )
      label horas
      PCheckbox(
        label="sem limite"
        v-model="dailyCheck[value.index]"
      )
    .negative(v-for="(value,lineIndex) in negativeNames" :style="`grid-row: ${2 + lineIndex}`")
      label {{value.name}}
      PTextField.input(
        :disabled="dailyCheck[value.index]"
        label=""
        type="number"
        parser="float"
        v-model="dailyLimitPerHourKind[value.index]"
      )
      label horas
      PCheckbox(
        label="sem limite"
        v-model="dailyCheck[value.index]"
      )
    .total(v-for="value in generalNames" :style="value.style")
      label {{value.name}}
      PTextField.input(
        :disabled="dailyCheck[value.index]"
        label=""
        type="number"
        parser="float"
        v-model="dailyLimitPerHourKind[value.index]"
      )
      label horas
      PCheckbox(
        label="sem limite"
        v-model="dailyCheck[value.index]"
      )
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DailyCheck.vue',
  data () {
    return {
      positiveNames: [
        {index: 0, name: 'horas extras, limite de'},
        {index: 1, name: 'horas extras extraordinárias, limite de'},
        {index: 2, name: 'horas extras especiais, limite de'}
      ],
      negativeNames: [
        {index: 4, name: 'atraso, limite de'},
        {index: 5, name: 'saída antecipada, limite de'},
        {index: 6, name: 'pausa em excesso, limite de'},
        {index: 7, name: 'horas de falta, limite de'}
      ],
      generalNames: [
        {index: 3, name: 'acúmulo geral, limite de', style: 'grid-row: 6; grid-column: 1/2; border-top: 1px solid lightgray;'},
        {index: 8, name: 'compensação geral, limite de', style: 'grid-row: 6; grid-column: 2/3; border-top: 1px solid lightgray;'},
        {index: 9, name: 'total, limite de', style: 'grid-row: 7; grid-column: 1/2;'}
      ]
    }
  },
  computed: {
    ...mapState('timeoff/details', ['dailyCheck', 'dailyLimitPerHourKind'])
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 20px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;

  .positive { grid-column: 1 / 2; }
  .negative { grid-column: 2 / 3; }
  .positive, .negative, .total {
    display: grid;
    grid-template-columns: 50% min-content 10% 30%;
    align-items: center;

    .input {
      width: 100px;
    }
  }
}
</style>
